/* eslint-disable */

export const parseContextToLegacy = (shopContext) => {
  if (!shopContext) return {};

  const legacyShopContext = {
    id: shopContext.contextId,
    name: shopContext.name,
    channel: shopContext.systemSettings.channel,
    shippingInformation: {
      hasMiintoAgreement: shopContext.shippingDetails.hasShippingAgreement,
      pickupPoints: shopContext.shippingDetails.pickupPoints,
    },
    availabilityOptions: {
      refundProduct: shopContext.systemSettings.refund,
      rma: shopContext.systemSettings.return,
      shipping: {modification: shopContext.systemSettings.shipping.modifications, documentsTypes: shopContext.systemSettings.shipping.documentTypes}
    }
  };
  return legacyShopContext;
};

export const getContextId = (context, response) => {
  const isNewFormat = Boolean(context.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i)?.[0])
  const oldShopId = response?.data?.items[0]?.id;
  return isNewFormat ? context : oldShopId
}

export const getChannelUUID = (response) => response?.data?.items[0]?.systemSettings?.channel?.ids?.[0]

export const getOrderIdFromUUID = (uuid) => uuid ? parseInt(uuid?.split('-')?.[4], 16) : null
export const getReturnIdfromUUID = (uuid) => uuid ? parseInt(uuid?.split('-')?.[0], 16) : null

export const verifyOrderIdFormat = (uuid, id) => uuid?.includes("8637e025-ae91-48de-002d") ? `${uuid} || ${id}` : uuid
export const verifyReturnIdFormat = (uuid, id) => uuid?.includes("40ed992032e2") ? `${uuid} || ${id}` : uuid
